import { render, staticRenderFns } from "./newVehicleDisplayPage.vue?vue&type=template&id=07cd46d6"
import script from "./newVehicleDisplayPage.vue?vue&type=script&lang=js"
export * from "./newVehicleDisplayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports